import {
  ContentTagListResponse,
  ContentTagSummaryModel,
  ContentTagViewPatternListResponse,
  ContentTagViewPatternResponse,
  IncludeReadOnlyQuery,
} from 'types/entity';
import { http } from 'api/settings';
import { AxiosResponse } from 'axios';

/**
 *(008001) 内容タグツリー取得
 * @param projectId
 */
export const fetchContentTags = (projectId: string, includeReadOnly: IncludeReadOnlyQuery): Promise<ContentTagSummaryModel[]> => http
  .get(`/projects/${projectId}/content-tags`, { params: { include_read_only_flag: includeReadOnly } })
  .then((response: AxiosResponse<ContentTagListResponse>) => response.data.content_tags || []);

/**
 *(010001) 内容タグViewパターン一覧取得
 * @param projectId
 * @param contentTagId
 */
export const fetchContentTagViewPatterns = (projectId: string, contentTagId: string): Promise<Array<ContentTagViewPatternResponse>> => http.get(`/projects/${projectId}/content-tags/${contentTagId}/views`)
  .then((response: AxiosResponse<ContentTagViewPatternListResponse>) => response.data.content_tag_view_patterns || []);
